let activeCustomerRegardId: null | string = null

// Holds the active customer's `customer_regard_id` so the RTK Query baseQuery — which runs outside React and cannot
// call `useParams` — can read it. Mirrors the `sec` token bridge; kept in sync from the customer-scoped layout that
// owns the `/c/:customer/` route.
export const customerHolder = {
  get: (): null | string => activeCustomerRegardId,
  set: (customerRegardId: null | string) => {
    activeCustomerRegardId = customerRegardId
  },
}
